import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMenu = () => {
  return (
    <g>
      <path d="M15.254 12.5c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 13.254v-.008c0-.412.334-.746.746-.746h14.508zm0-5.25c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 8.004v-.008c0-.412.334-.746.746-.746h14.508zm0-5.25c.412 0 .746.334.746.746v.008a.746.746 0 0 1-.746.746H.746A.746.746 0 0 1 0 2.754v-.008C0 2.334.334 2 .746 2h14.508z" />
    </g>
  );
};

export default withIcon(IconMenu);
